export default "__VITE_ASSET__DHtfoV_k__"